import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=805d2990&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"
import style0 from "./Company.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('805d2990')) {
      api.createRecord('805d2990', component.options)
    } else {
      api.reload('805d2990', component.options)
    }
    module.hot.accept("./Company.vue?vue&type=template&id=805d2990&", function () {
      api.rerender('805d2990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Company/Crud/Company.vue"
export default component.exports